import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";

export const reportG9 = {
    getReportData
};
function getReportData(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG9/getReportData/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}